<template>
  <v-navigation-drawer app fill-height fixed v-model="drawer">
    <v-container class="pb-2">
      <v-layout justify-center row>
        <v-avatar size="90">
          <v-icon size="90">account_circle</v-icon>
        </v-avatar>
      </v-layout>
    </v-container>
    <v-container class="pt-0">
      <v-layout justify-center row>
        <span class="headline">{{ me.firstName }} {{ me.lastName }}</span>
      </v-layout>
      <v-layout justify-center row v-if="me.vscId !== ''">
        <span class="caption">{{ me.vscId }}</span>
      </v-layout>
    </v-container>
    <v-container class="pa-0">
      <v-layout column>
        <div class="px-4">
          <v-btn @click="createRun()" block color="info" round>Create a new run</v-btn>
        </div>
        <v-list dense>
          <v-list-tile :to="{name: 'runs'}">
            <v-list-tile-action>
              <v-icon>directions_run</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>My Runs</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile :to="{name: 'credits'}">
            <v-list-tile-action>
              <v-icon>local_gas_station</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>My Credits</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <v-divider></v-divider>
        <v-list dense>
          <v-list-tile :to="{name: 'settings'}">
            <v-list-tile-action>
              <v-icon>settings</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Settings</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="logout">
            <v-list-tile-action>
              <v-icon>power_settings_new</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Logout</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-layout>
    </v-container>
    <v-container>
      <span class="caption">
        Based on
        <a href="https://github.com/jpomoell/euhforia/tree/py3" target="_blank">EUHFORIA v1.1.0</a>
      </span>
      <br />
      <span class="caption">
        Developed by
        <a href="http://raysofspace.com/" target="_blank">Rays of Space Oy</a>
      </span>
      <br />
      <span class="caption">All rights reserved &copy; 2020</span>
    </v-container>
  </v-navigation-drawer>
</template>

<script>
import meMixin from '@/mixins/me';
import { onLogout } from '@/vue-apollo';
import defaultConfig from '@/config.run';
import { MY_RUNS, CREATE_RUN } from '@/graphql.gql';

export default {
  mixins: [meMixin],
  computed: {
    drawer: {
      get() {
        return this.$store.getters.drawer;
      },
      set(value) {
        this.$store.dispatch('setDrawer', value);
      },
    },
  },
  methods: {
    async createRun() {
      try {
        this.$wait.start('busy');
        await this.$apollo.mutate({
          mutation: CREATE_RUN,
          variables: { config: JSON.stringify(defaultConfig) },
          update: (store, { data: { createRun } }) => {
            const data = store.readQuery({ query: MY_RUNS });
            data.myRuns.push(createRun);
            store.writeQuery({ query: MY_RUNS, data });
            this.$router.push({ name: 'run', params: { id: createRun.id } });
          },
        });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
        this.$snackbar.show('We could not create a new run. Please, try again.');
      } finally {
        this.$wait.end('busy');
      }
    },
    async logout() {
      try {
        this.$wait.start('busy');
        await onLogout(this.$apollo.provider.defaultClient);
        this.$auth.logout();
        await this.$store.dispatch('refreshToken');
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
        this.$snackbar.show('Something went wrong. Please, try again.');
      } finally {
        this.$wait.end('busy');
      }
      this.$router.push({ name: 'signin' });
    },
  },
};
</script>
